require('velocity-animate') // Javascipt engine for snappier animations

$(() => {
  const bodyTag = $('body')

  //
  // Hamburger and Nav
  //
  const hamburgerTag = $('.c-hamburger')
  const navigationTag = $('.c-nav')

  hamburgerTag.on('click', function (e) {
    hamburgerTag.toggleClass('is-active')
    navigationTag.toggleClass('is-active')
    bodyTag.toggleClass('menu-open')
  })

  $(document).on('keydown', function (e) {
    if (e.keyCode === 27) { // ESC
      hamburgerTag.removeClass('is-active')
      navigationTag.removeClass('is-active')
      bodyTag.removeClass('menu-open')
    }
  })

  //
  // Append subnav buttons to main nav
  //

  const loginHref = $('.tn-utility-nav-account-login-link').attr('href')
  const accountHref = $('.tn-utility-nav-account-menu__section .tn-utility-nav-account-menu__link:nth-child(2').attr('href')
  const cartHref = $('.tn-utility-nav-cart-link').attr('href')

  $('.c-header__link--cart').attr('href', cartHref)
  if ($('.tn-utility-nav-account-section--logged-in').length) {
    $('.c-header__link--user').attr('href', accountHref)
    $('.c-header__link--user label').html('Account')
  } else {
    $('.c-header__link--user').attr('href', loginHref)
  }

  //
  // Layout
  //
  // Remove block buttons
  $('.btn').removeClass('btn-block')

  // Append password button next to Login button
  if ($(bodyTag).hasClass('account-login')) {
    $('#tn-login-button, #tn-account-login-forgot-login-link').wrapAll("<div class='js-login__button-container'></div>")
  }
  if ($(bodyTag).hasClass('account-interests') || $('body').hasClass('account-update')) {
    $('.tn-btn-grouped').wrapAll("<div class='js-login__button-container'></div>")
    $('a.tn-btn-grouped').removeClass('btn btn-default')
  }

  //
  // Add inactive class to unhovered list items
  //

  $('.c-footer__nav a').hover(function () {
    $('.c-footer__nav a').not(this).toggleClass('not-active')
  })

  $('.c-footer__social a').hover(function () {
    $('.c-footer__social a').not(this).toggleClass('not-active')
  })

  $('.c-header__link').hover(function () {
    $('.c-header__link').not(this).toggleClass('not-active')
  })
  $('.c-menu__link').hover(function () {
    $('.c-menu__link').not(this).toggleClass('not-active')
  })

  // A price type placeholder box with white space characters
  // Hide it when there's no actual text inside
  const emptyElements = document.querySelectorAll('.tn-empty-cart-message, #instructions-choose-zone')
  if (emptyElements && emptyElements.length) {
    emptyElements.forEach(element => {
      if (!element.innerText.length) {
        element.style.display = 'none'
      }
    })
  }
})
